module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAPCAMAAAA4caRkAAAAAXNSR0IArs4c6QAAADZQTFRFAAAA////////////////////////////////////////////////////////////////////8WPG/AAAABF0Uk5TAAwaPFdYWW5wcaG2t8Pa8/w0r7B1AAAAWUlEQVQY023PMRaAIAwE0QmIioqQ+1/WBmPwseWfasEWT2GyWLXIlHUSYlWdhM7/YDwGxz50vrc2hJcDqw8f44NnSBYuzxYWpHjuIQNSPENqmgGQIwzf0w48tRgI6+FUUkIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/symbol_below@2x.png
// module id = Y+b4
// module chunks = 1